import * as React from 'react'
import { Link } from '@tanstack/react-router'
import { Undo2 } from 'lucide-react'
import { cn } from '@/utils/cn'

export interface BackLinkProps {
  label?: string
  title?: React.ReactNode
  to?: string
  onClick?: () => void
  className?: string
}

export function BackLink({
  label = 'Quay lại',
  title,
  to,
  onClick,
  className,
}: BackLinkProps) {
  const trigger = (
    <span className="inline-flex items-center gap-1.5 text-sm text-primary transition-opacity hover:opacity-80 py-1">
      <Undo2 className="h-4 w-4" />
      {label}
    </span>
  )

  return (
    <div className={cn('flex items-center gap-4 py-4', className)}>
      {to ? (
        <Link to={to} className="no-underline">
          {trigger}
        </Link>
      ) : (
        <button
          type="button"
          onClick={onClick}
          className="cursor-pointer border-none bg-transparent p-0"
        >
          {trigger}
        </button>
      )}
      {title && (
        <h2 className="m-0 text-sm font-semibold uppercase tracking-wide text-gray-900">
          {title}
        </h2>
      )}
    </div>
  )
}
